import * as React from 'react';
import styled from 'styled-components';

// ############################ Styles ###########################

const SToast = styled.div(({ theme }) => {
  return `
    position: absolute;
    bottom: 50px;
    margin: auto;
    font-weight: ${theme.font.weight.light};
    font-size: ${theme.font.size.smaller};
    color: ${theme.colors.white};
    background: rgba(0,0,0,0.6);
    padding: 5px 20px;
    border-radius: 5px;
    opacity: 1;
    transition: opacity 0.5s;
    &.hide {
        opacity: 0;
        transition: opacity 2s;
    }`;
});

const SClickWrapper = styled.div(({ theme }) => {
  return `
    & button {
      cursor: pointer;
      margin-left: 20px;
      background: white;
      border: 1px solid black;
      padding: 3px 10px;
      border-radius: 5px;
      font-weight: medium;
  }
  `;
});

const SWrapper = styled.div(({ theme }) => {
  return `
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100vw;
    height: auto;
    display: flex;
    justify-content: center;
  `;
});

// ############################ End Styles ###########################

export interface IToastProps {
  text: string;
  children: JSX.Element[] | JSX.Element;
  callback: () => void;
  className?: string;
}

export default ({ className, text, children, callback }: IToastProps) => {
  const toastRef = React.useRef(null);

  const clickHandler = () => {
    callback();
    toastRef.current.classList.remove('hide');
    setTimeout(() => toastRef.current.classList.add('hide'), 2000);
  };

  return (
    <SClickWrapper {...{ className, onClick: clickHandler }}>
      {children}
      <SWrapper>
        <SToast ref={toastRef} className="hide">
          {text}
        </SToast>
      </SWrapper>
    </SClickWrapper>
  );
};
